import { Person } from 'models'
import { PaginationSearchBase } from 'store/PaginationSearchBase'
import { TriggerSearchFunc } from 'store/PaginationSearchBase/PaginationSearchBase.types'
import { PERSON_STORE } from 'store/PersonStore'
import { RootStore } from 'store/RootStore'
import { getSortingResult } from 'utilities'
import {
  initialPersonsTableSearchProps, initialPersonsTablePaginationProps,
  PersonsTableSearchProps, PersonsTableSortProps, personsTableNeedTimeoutProps
} from './PersonsTableStore.types'

export const PERSONS_TABLE_STORE = 'PERSONS_TABLE_STORE'

export class PersonsTableStore extends PaginationSearchBase<
  PersonsTableSortProps,
  PersonsTableSearchProps,
  Person
  > {
  private _rootStore: RootStore

  constructor (rootStore: RootStore) {
    super(
      initialPersonsTablePaginationProps,
      initialPersonsTableSearchProps,
      [],
      personsTableNeedTimeoutProps
    )
    this._rootStore = rootStore
  }

  triggerSearch: TriggerSearchFunc = () => {
    const { personsList } = this._rootStore[PERSON_STORE]
    const {
      name,
      projectName,
      tags,
      role,
      minAddedAt,
      maxAddedAt
    } = this.searchProps

    const results = personsList.filter(p => {
      const nameFilter = name
        ? p.name.toLowerCase().includes(name.trim().toLowerCase())
        : true
      const roleFilter = role
        ? p.roles.includes(role)
        : true
      const projectFilter = projectName
        ? p.projects.some(project =>
          project.name.toLowerCase().includes(projectName.trim().toLowerCase())
        )
        : true
      const addedAtFilter = minAddedAt
        ? p.createdDate.isBetween(minAddedAt, maxAddedAt, undefined, '[]')
        : true
      const tagsFilter = p.tags.toLowerCase().includes(tags.trim().toLowerCase())

      return nameFilter &&
        roleFilter &&
        projectFilter &&
        addedAtFilter &&
        tagsFilter
    })

    const { sortProp, sortDirection } = this.pagination
    results.sort((a, b) => {
      switch (sortProp) {
        case PersonsTableSortProps.NAME: {
          return getSortingResult(a.name, b.name, sortDirection)
        }
        case PersonsTableSortProps.ROLES: {
          return getSortingResult(a.rolesAsString, b.rolesAsString, sortDirection)
        }
        case PersonsTableSortProps.PROJECTS: {
          return getSortingResult(
            a.projects.map(p => p.name).join(),
            b.projects.map(p => p.name).join(),
            sortDirection
          )
        }
        case PersonsTableSortProps.ADDED_AT: {
          return getSortingResult(a.createdDate, b.createdDate, sortDirection)
        }
        default: return 0
      }
    })

    this.setSearchResults(results)
  }
}
